<fab-loading-spinner *ngIf="isPageLoading"></fab-loading-spinner>
<mat-dialog-content>
    <div class="modal-container">
        <h1 class="header">Absence Request</h1>
        <form fxLayout="column" fxLayoutAlign="center" (ngSubmit)="submitForm()" #form="ngForm">
            <table>
                <tr>
                    <th id="half-day">Half Day:</th>
                    <td class="inline-block padding">AM:
                        <mat-checkbox id="halfDayAM" name="halfDayAM" (click)="deSelectPM()" [(ngModel)]="halfDayAM"></mat-checkbox>
                    </td>
                    <td class="inline-block">PM:
                        <mat-checkbox id="halfDayPM" name="halfDayPM" (click)="deSelectAM()" [(ngModel)]="halfDayPM"></mat-checkbox>
                    </td>
                </tr>
                <br/>
                <tr>
                    <th id="type">Request Type:</th>
                    <td>
                        <mat-form-field class="filterSize" appearance="outline">
                            <mat-label>Please select an absence type</mat-label>
                            <mat-select id="vacationType" name="vacationType" [(ngModel)]="model.absenceType" #vacationType required>
                                <mat-option *ngFor="let vacationOption of vacationOptions" [value]="vacationOption.value">
                                    {{vacationOption.displayValue}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th id="days">Days of Absence:</th>
                    <td>
                        <mat-form-field class="filterSize" appearance="outline">
                            <mat-label>{{ formattedStartDate && formattedEndDate ? formattedStartDate + ' - ' + formattedEndDate : 'Enter a date range' }}</mat-label>
                            <mat-date-range-input [formGroup]="startEndRange"
                                                  [rangePicker]="picker" [dateFilter]="makeWeekendUnselectable" [min]="minVacationDate" [max]="maxWorkAbroadDate" disabled required>
                                <input matStartDate formControlName="start" placeholder="Start date" required/>
                                <input matEndDate formControlName="end" placeholder="End date" required/>
                            </mat-date-range-input>
                            <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker disabled="false"
                                                   (opened)="this.isDuplicated=false"></mat-date-range-picker>

                            <mat-error *ngIf="startEndRange.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
                            <mat-error *ngIf="startEndRange.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
                        </mat-form-field>
                    </td>
                </tr>
                <tr>
                    <th id="details">Additional Details:</th>
                    <td *ngIf="vacationType.value !== 'HOLIDAY'">
                        <mat-form-field appearance="outline" style="width: 235px;">
                            <mat-label>Enter any additional details</mat-label>
                            <textarea id="additionalDetails" name="additionalDetails" [(ngModel)]="model.absenceReason" matInput cols="100" rows="5" minlength="8" [maxlength]="499" required (change)="this.stripWhiteSpace()"></textarea>
                            <mat-hint>Must be at least 8 characters</mat-hint>
                        </mat-form-field>
                    </td>
                    <td *ngIf="vacationType.value === 'HOLIDAY'">
                        <mat-form-field appearance="outline" style="width: 235px;">
                            <mat-label>Enter any additional details</mat-label>
                            <textarea id="additionalDetails" name="additionalDetails" [(ngModel)]="model.absenceReason" matInput cols="100" rows="5" minlength="0" [maxlength]="499" (change)="this.stripWhiteSpace()"></textarea>
                        </mat-form-field>
                    </td>
                </tr>
                <tr *ngIf="vacationType.value === 'HOSPITAL_APPOINTMENT'">
                    <th id="blank"></th>
                    <p class="hospital-info">*If you are applying for a full-day</p>
                    <p class="hospital-info">Hospital Appointment Leave,</p>
                    <p class="hospital-info">please provide rationale for that.</p>
                    <p class="hospital-info">Please refer to the employee handbook.</p>
                </tr>
            </table>
            <button mat-raised-button color="primary" [disabled]="!form.form.valid || !checkHolidayAllowance()">Submit</button>
            <div class="error-message" *ngIf="halfDayCorrect == false">
                <p>Half day must be limited to one day.</p>
            </div>
            <div class="error-message" *ngIf="isHospitalDayCorrect == false">
                <p>Hospital day must be limited to one day.</p>
            </div>
        </form>
    </div>
</mat-dialog-content>
